import { Form1099Status } from "@wingspanhq/payments/dist/interfaces";

const getStatusLabel = (status: Form1099Status) => {
  switch (status) {
    case Form1099Status.NeedsActionInfo:
    case Form1099Status.NeedsActionDispute:
      return "Needs Action";
    default:
      return status;
  }
};

export default getStatusLabel;
